export const publishableKey = 'pk_live_51OCKekBVziOsXKnnrW7qSE491AsZNJ2MTjqVijh7VVV85GexpkVvbmzx2TPQzc8ELIP9dzlJWPJUDfM7UK9Uwqsx00zRjkAlUQ';